export const LOGIN_TRANSLATE = {
  USERNAME_LABEL: "メールアドレス",
  USERNAME_PLACEHOLDER: "メールアドレスを入力してください",
  PASSWORD_LABEL: "パスワード",
  PASSWORD_PLACEHOLDER: "パスワードを入力してください",

  BTN_LOGIN: "ログイン",
  BTN_FORGOT_PASSWORD: "パスワードを忘れた場合",
};
